import Fire, { firebaseAuth, googleProvider } from '../config/Fire';
import {
	AUTHENTICATE,
	AUTHENTICATE_SUCCESS,
	AUTHENTICATE_FAIL,
	AUTHENTICATE_ANONYMOUS,
	AUTHENTICATE_ANONYMOUS_SUCCESS,
	AUTHENTICATE_ANONYMOUS_FAIL,
} from './types';

export const logout = () => {
	return dispatch => {
		firebaseAuth().signOut();
		dispatch({ type: AUTHENTICATE_FAIL });
	};
};

export const signInWithGoogle = () => {
	return dispatch => {
		dispatch({ type: AUTHENTICATE });
		firebaseAuth()
			.signInWithPopup(googleProvider)
			.then(res => {
				_createUser(res.user, dispatch);
			})
			.catch(_e => {
				dispatch({ type: AUTHENTICATE_FAIL, payload: _e });
				console.log(_e);
			});
	};
};

export const signInAnonymously = () => {
	return dispatch => {
		dispatch({ type: AUTHENTICATE_ANONYMOUS });
		firebaseAuth()
			.signInAnonymously()
			.then(res => {
				dispatch({ type: AUTHENTICATE_ANONYMOUS_SUCCESS, payload: res.user });
			})
			.catch(_e => {
				dispatch({ type: AUTHENTICATE_ANONYMOUS_FAIL, payload: _e });
				console.log(_e);
			});
	};
};

export const authenticateSuccess = user => {
	return dispatch => {
		_createUser(user, dispatch);
	};
};

const _createUser = (user, dispatch) => {
	Fire.firestore()
		.collection('users')
		.doc(user.uid)
		.set(
			{
				displayName: user.displayName,
				email: user.email,
				emailVerified: user.emailVerified,
			},
			{ merge: true },
		)
		.then(function() {
			dispatch({ type: AUTHENTICATE_SUCCESS, payload: user });
		})
		.catch(function(_e) {
			dispatch({ type: AUTHENTICATE_FAIL, payload: _e });
		});
};

export const authenticateFail = () => ({
	type: AUTHENTICATE_FAIL,
});

export const activeUser = user => ({
	type: AUTHENTICATE_SUCCESS,
	payload: user,
});

export default { signInWithGoogle, authenticateSuccess, authenticateFail };



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js